
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import Job, { JobInfo, WhiteUser, CommonParam, JobExam } from "@/lib/job/job";
import ExamList from "@/lib/model/exam/exam";
import Auth from "@/lib/common/auth";
import DelExamModal from "../components/del-exam-modal.vue";
import {
  ExamCopyForm,
  ExamDeleteForm,
  ExamGetForm
} from "@/lib/form/exam/ExamListForm";

import _ from "lodash-es";
@Component({
  components: { DelExamModal }
})
export default class AllList extends Vue {
  @Prop({}) exam!: ExamV2Custom;
  @Prop({}) visible!: boolean;

  tableData: any = [];
  allList: any = [];
  pageNumber = 1;
  editNameParam = {
    examId: 0,
    name: "",
    remark: ""
  };
  isShowDelModal = false;
  examDeleteForm = new ExamDeleteForm();

  get title() {
    return this.exam.name || "全部" + "的题目包";
  }

  created() {
    //
  }
  mounted() {
    this.getList();
  }

  async getList() {
    const data = await Job.getAllExam({
      examIdList: this.exam.subExamIdList,
      onlySubExam: 1,
      returnAll: true
    });
    this.allList = data.list;
    if (this.allList.length > 20) {
      this.tableData = this.allList.slice(0, 20);
    } else {
      this.tableData = data.list;
    }
    // const { exams } = await ExamList.getList({ examIdList: this.exam.subExamIdList })
    // this.tableData = exams
  }

  handleCurrentChange(pageNumber: number) {
    this.pageNumber = pageNumber;
    this.tableData = this.allList.slice(
      0 + (this.pageNumber - 1) * 20,
      20 + (this.pageNumber - 1) * 20
    );
  }

  async ok() {
    //todo 一些校验可以在这里做
    await this.checkData();

    this.$emit("ok", "xxx");
    this.close();
  }

  //关闭
  close() {
    this.$emit("update:visible", false);
  }
  //离开前校验
  async checkData() {
    return new Promise((resolve, reject) => {
      //do something
      resolve(true);
      // reject(false);
    });
  }
  delCancel() {
    this.isShowDelModal = false;
  }
  delSuccess() {
    ExamList.examDeleteAi(this.examDeleteForm).then(res => {
      if (res.code === 0) {
        this.isShowDelModal = false;
        this.$message.success("删除成功");
        this.getList();
      }
    });
  }
  deleteItem(row: any) {
    this.editNameParam = {
      name: row.name,
      remark: row.remark,
      examId: row.examId
    };
    this.examDeleteForm.companyId = parseInt(Auth.companyId);
    this.examDeleteForm.examId = row.examId;
    console.log(row);
    this.isShowDelModal = true;
  }
  editItem(row: any) {
    const { href } = this.$router.resolve({
      name: "ai-builder",
      query: { paperId: row.examId, cid: Auth.companyId, step: "2" }
    });
    window.open(href, "_blank");
  }
}
